/* Almila Viber bar (sections/almila-viber-bar.liquid; maintenance/almila-viber.md).
   Sets data-shown while the header is off the screen and clears it while any of the header is in view, so the bar
   never covers the header or its menu button. The bar's CSS shows it only below 992px. */
(() => {
  if (customElements.get('almila-viber-bar')) return;
  // The header's section in the header group; the bar's own section is in the same group.
  const HEADER = '.shopify-section-group-header-group:not(.almila-viber-bar-section)';

  class AlmilaViberBar extends HTMLElement {
    connectedCallback() {
      const header = document.querySelector(HEADER);
      if (!header || !this.querySelector('a')) return;
      this.observer = new IntersectionObserver(([entry]) => this.toggleAttribute('data-shown', !entry.isIntersecting));
      this.observer.observe(header);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  customElements.define('almila-viber-bar', AlmilaViberBar);
})();
